export const TABLE_HEADER_COLUMNS = [
  'Date',
  'Order #',
  'Owner Email',
  'Client',
  'Company',
];

export enum SORT_TYPES {
  UP = 'createdAt',
  DOWN = '-createdAt',
}
